var _linearGradient, _path, _linearGradient2, _path2, _linearGradient3, _path3, _linearGradient4, _path4, _linearGradient5, _path5, _linearGradient6, _path6, _linearGradient7, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttendance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 198.425 198.425",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_a0cb8376fa5be578a44eab5947ca6855d8d2a12c659138b3643bdfc0a3849782",
    gradientUnits: "userSpaceOnUse",
    x1: 1047.862,
    y1: -249.097,
    x2: 1048.862,
    y2: -249.097
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M71.652 80.947h11.615M17.724 80.947h11.59M90.107 21.104v101.86M96.755 81.383s5.109 7.513 11.721 0c0 0 5.302 8.093 12-.279M130.244 81.383s5.109 7.513 11.721 0c0 0 5.302 8.093 12-.279 0 0 5.302 8.372 12.419-.14 0 0 5.628 7.581 12.14.14"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_a0cb8376fa5be578a44eab5947ca6855d8d2a12c659138b3643bdfc0a3849782",
    gradientUnits: "userSpaceOnUse",
    x1: 896.617,
    y1: 199.829,
    x2: 927.168,
    y2: 199.829,
    gradientTransform: "rotate(-17.541 143.04 2690.206)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M128.024 50.369s-3.136 4.894-5.989 21.795c-2.853 16.901-1.729 41.742-1.729 41.742s1.989 2.246 5.055 2.367c4.046.18 6.837-2.89 6.837-2.89s-5.581-15.349-.279-55.814",
    fill: "none",
    stroke: "url(#SVGID_1_a0cb8376fa5be578a44eab5947ca6855d8d2a12c659138b3643bdfc0a3849782)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_a0cb8376fa5be578a44eab5947ca6855d8d2a12c659138b3643bdfc0a3849782",
    gradientUnits: "userSpaceOnUse",
    x1: -72.375,
    y1: 47.495,
    x2: -34.387,
    y2: 47.495,
    gradientTransform: "scale(-1 1) rotate(5.475 21.467 -833.118)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M140.85 42.095s2.819-1.298 6.442-4.449 6.858-8.881 6.858-8.881-4.167.399-10.925 3.01c-6.759 2.61-10.295 7.154-10.295 7.154s-3.874-3.367-7.2-4.917c-3.326-1.55-6.924-2.046-6.924-2.046s2.271 7.118 6.36 9.81",
    fill: "none",
    stroke: "url(#SVGID_2_a0cb8376fa5be578a44eab5947ca6855d8d2a12c659138b3643bdfc0a3849782)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_a0cb8376fa5be578a44eab5947ca6855d8d2a12c659138b3643bdfc0a3849782",
    gradientUnits: "userSpaceOnUse",
    x1: -289.29,
    y1: 92.657,
    x2: -218.694,
    y2: 92.657,
    gradientTransform: "rotate(8.583 191.584 2660.535)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M129.543 42.283s-8.323-1.158-18.927 5.518c-8.534 6.049-10.605 8.372-10.605 8.372s6.83 2.812 18.233-1.674 12.361-6.787 12.361-6.787-.314 5.151 1.33 10.346c4.056 11.312 8.958 11.369 8.958 11.369s1.948-7.7-3.473-20.121c0 0 2.201 3.312 14.871 6.263 13.367 2.162 16.744-.419 16.744-.419s-4.465-7.535-16.744-10.884c-10.319-2.688-14.698-1.708-14.698-1.708",
    fill: "none",
    stroke: "url(#SVGID_3_a0cb8376fa5be578a44eab5947ca6855d8d2a12c659138b3643bdfc0a3849782)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_a0cb8376fa5be578a44eab5947ca6855d8d2a12c659138b3643bdfc0a3849782",
    gradientUnits: "userSpaceOnUse",
    x1: 28.715,
    y1: 76.522,
    x2: 72.238,
    y2: 76.522
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_4_a0cb8376fa5be578a44eab5947ca6855d8d2a12c659138b3643bdfc0a3849782)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M29.965 61.453h41.023v30.139H29.965z"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_a0cb8376fa5be578a44eab5947ca6855d8d2a12c659138b3643bdfc0a3849782",
    gradientUnits: "userSpaceOnUse",
    x1: 33.459,
    y1: 76.499,
    x2: 67.316,
    y2: 76.499
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_5_a0cb8376fa5be578a44eab5947ca6855d8d2a12c659138b3643bdfc0a3849782)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M34.709 66.476h31.357v20.047H34.709z"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_a0cb8376fa5be578a44eab5947ca6855d8d2a12c659138b3643bdfc0a3849782",
    gradientUnits: "userSpaceOnUse",
    x1: 22.994,
    y1: 96.197,
    x2: 77.819,
    y2: 96.197
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_6_a0cb8376fa5be578a44eab5947ca6855d8d2a12c659138b3643bdfc0a3849782)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M30.197 91.499l-5.953 9.674h52.325l-5.72-9.953"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttendance);
export default __webpack_public_path__ + "static/media/attendance.5adc6a9c2b2cece766a8a02607fd3916.svg";
export { ForwardRef as ReactComponent };